const Data = [
  {
    name: "Aman Rao",
    position: "RISE Head",
    imageUrl: "/assets/images/members/Heads26/AmanRao.jpg",
    facebookLink: "https://www.facebook.com/profile.php?id=61564331553062",
    email: "amankgpian.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/aman-rao-638461311?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  },
  {
    name: "Ipsita Hansda",
    position: "RISE Head",
    imageUrl: "/assets/images/members/Heads26/IpsitaHansda.jpeg",
    facebookLink: "https://www.facebook.com/share/1J7xjXDte4/",
    email: "ipsita04.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/ipsita-hansda-170107335?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  },
  {
    name: "Nandini",
    position: "RISE Head",
    imageUrl: "/assets/images/members/Heads26/Nandini.jpeg",
    facebookLink: "https://www.facebook.com/share/18tfJdhvyB/",
    email: "nandini.2505.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/nandini-916732326?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  }
];

export default Data;